import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import MoviesPage from "@/pages/movies/page";
import HotTopicsPage from "@/pages/hot-topics/page";
import DetailPage from "@/pages/detail/page";
import MovieDetailPage from "@/pages/movie/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsPage /> },
      { path: "movies", element: <MoviesPage /> },
      { path: "hot-topics", element: <HotTopicsPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "movie/:id", element: <MovieDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;